import _ from "lodash";
import {
  Component,
} from "react";
import {
  Spinner,
} from "CommonComponents/bricks";
import store from "CommonState/store";
import antragApi from "Apis/antrag-api";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import SHKFormTab, {
  setupAntragPanels,
} from "App/shk-form-tab";
import {
  subpanels as subpanels_studien,
} from "App/person-studien-tab";
import {
  ANTRAGSTELLERMODUS,
  ASTMODUSKEY,
  getModusFromAntrag,
  ROLLEN,
} from "App/constants";

const panels = _.cloneDeep([...subpanels_studien]);
const mapping = [{ endpoint: "/api/shkperson/studienbereich", prop: "antrag_studienbereich", pfrom: "psb_", pto: "asb_" },
                 { endpoint: "/api/shkperson/werdegang", prop: "antrag_werdegang", pfrom: "pwg_", pto: "awg_" }];
setupAntragPanels(panels, mapping);

const injects = _.flatMap(panels, s => injectsFromSchema(s.schema));
const selectInjects = createInjectsSelector(injects);

@store(...injects, "user")
@antragApi.current
export default class AntragStudienTab extends Component {
  constructor() {
    super();
    this.state = { filteredSubpanels: null };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { currentAntrag } = nextProps;

    // Nur neu berechnen wenn sich currentAntrag geändert hat
    if (prevState.lastAntragId !== currentAntrag?.a_id) {
      const modus = currentAntrag && ANTRAGSTELLERMODUS[getModusFromAntrag(currentAntrag)];
      const lehrvertrag = modus?.value === ASTMODUSKEY.Lehrauftrag;
      const tarifvertrag = modus?.value === ASTMODUSKEY.Tarif;

      const filteredSubpanels = panels.filter(x => {
        // PBP-ss88 kein Studium Block für Tarif oder LBA
        return !((lehrvertrag || tarifvertrag) && x.key === "studienbereich")
              && (tarifvertrag || x.key != "ausbildung");
      }).map(x => {
        if (x.key == "werdegang") {
          if (lehrvertrag) {
            x.label = "Qualifikation";
          }
          const ha = x.schema.table.find(x => x.field == "awg_pfaid");
          if (ha) {
            if (lehrvertrag) {
              ha.display = "Höchster Hochschulabschluss";
            } else {
              ha.display = "Hochschulabschluss";
            }
          }
        }
        return x;
      });

      return {
        filteredSubpanels,
        lastAntragId: currentAntrag?.a_id,
      };
    }

    return null; // Keine State-Änderung
  }

  componentDidMount() {
    // Falls bei Mount noch keine filteredSubpanels gesetzt wurden
    if (!this.state.filteredSubpanels && this.props.currentAntrag) {
      this.setState(AntragStudienTab.getDerivedStateFromProps(this.props, this.state));
    }
  }

  render() {
    const { currentAntrag, user } = this.props;
    if (!currentAntrag) {
      return <Spinner />;
    }

    // Für Sachb alle Hilfstexte herausfiltern
    if (user.ro_id != ROLLEN.ROLLE_ANTRAGSTELLER) {
      _.map(panels, p => p.schema.table = p.schema.table.filter(f => f.type != "plaintext"));
    }
    return this.state.filteredSubpanels && <SHKFormTab readonly args={{ a_id: currentAntrag.a_id }}
      subpanels={this.state.filteredSubpanels}
      injects={selectInjects(this.props)} />;
  }
}
